(function () {
  'use strict';

  var SOLD_OUT_SUFFIX = ' (Agotado)';
  var productData = null;
  var refreshTimer = null;
  var isApplying = false;

  function normalize(value) {
    return String(value == null ? '' : value)
      .replace(/\s+\(Agotado\)$/i, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function getBaseLabel(option) {
    if (!option.dataset.ssmxBaseLabel) {
      option.dataset.ssmxBaseLabel = String(option.textContent || '')
        .replace(/\s+\(Agotado\)$/i, '')
        .trim();
    }
    return option.dataset.ssmxBaseLabel;
  }

  function optionMatchesValue(option, variantValue) {
    var expected = normalize(variantValue);
    return normalize(option.value) === expected || normalize(getBaseLabel(option)) === expected;
  }

  function setOptionAvailability(option, available) {
    var baseLabel = getBaseLabel(option);
    option.disabled = !available;
    option.setAttribute('aria-disabled', available ? 'false' : 'true');
    option.classList.toggle('ssmx-option-agotada', !available);
    option.textContent = baseLabel + (available ? '' : SOLD_OUT_SUFFIX);
  }

  function dispatchChange(select) {
    var event;
    try {
      event = new Event('change', { bubbles: true });
    } catch (error) {
      event = document.createEvent('Event');
      event.initEvent('change', true, true);
    }
    select.dispatchEvent(event);
  }

  function selectFirstAvailable(select) {
    var selected = select.options[select.selectedIndex];
    if (selected && !selected.disabled && selected.value !== '') return false;

    var options = Array.prototype.slice.call(select.options);
    var firstAvailable = options.find(function (option) {
      return !option.disabled && option.value !== '';
    });

    if (!firstAvailable) return false;

    firstAvailable.selected = true;
    select.value = firstAvailable.value;
    dispatchChange(select);
    return true;
  }

  function optionHasAvailableVariant(selects, optionIndex, option) {
    return productData.variants.some(function (variant) {
      if (!variant.available || !variant.options || !optionMatchesValue(option, variant.options[optionIndex])) {
        return false;
      }

      for (var index = 0; index < selects.length; index += 1) {
        if (index === optionIndex) continue;

        var otherSelect = selects[index];
        var otherOption = otherSelect.options[otherSelect.selectedIndex];
        if (!otherOption || otherOption.value === '' || otherOption.disabled) continue;

        if (!optionMatchesValue(otherOption, variant.options[index])) return false;
      }

      return true;
    });
  }

  function processPrimarySelectors() {
    var container = document.querySelector('.tt-product-single-info .tt-swatches-container-js');
    if (!container || !productData) return false;

    var selects = Array.prototype.slice.call(container.querySelectorAll('select'));
    if (!selects.length) return false;

    selects.forEach(function (select, optionIndex) {
      var options = Array.prototype.slice.call(select.options);

      options.forEach(function (option) {
        getBaseLabel(option);

        if (option.value === '' && !normalize(option.textContent)) return;
        if (option.value === '' && /selecciona|choose|select/i.test(getBaseLabel(option))) {
          option.disabled = true;
          option.setAttribute('aria-disabled', 'true');
          return;
        }

        setOptionAvailability(
          option,
          optionHasAvailableVariant(selects, optionIndex, option)
        );
      });

      var selectableOptions = options.filter(function (option) {
        return option.value !== '' && !option.disabled;
      });

      select.classList.toggle('ssmx-no-available-options', selectableOptions.length === 0);
      select.setAttribute('aria-label', select.getAttribute('aria-label') || 'Seleccionar opción disponible');
      select.disabled = selectableOptions.length === 0;
    });

    var changed = false;
    selects.forEach(function (select) {
      if (!select.disabled && selectFirstAvailable(select)) changed = true;
    });

    return changed;
  }

  function processStickySelector() {
    if (!productData) return false;

    var variantsById = new Map();
    productData.variants.forEach(function (variant) {
      variantsById.set(String(variant.id), variant);
    });

    var changed = false;
    var stickySelects = document.querySelectorAll('.tt-fixed-product-wrapper select');

    Array.prototype.forEach.call(stickySelects, function (select) {
      var options = Array.prototype.slice.call(select.options);

      options.forEach(function (option) {
        var variant = variantsById.get(String(option.value));
        if (!variant) return;
        setOptionAvailability(option, Boolean(variant.available));
      });

      var selectableOptions = options.filter(function (option) {
        return option.value !== '' && !option.disabled;
      });

      select.classList.toggle('ssmx-no-available-options', selectableOptions.length === 0);
      select.disabled = selectableOptions.length === 0;

      if (!select.disabled && selectFirstAvailable(select)) changed = true;
    });

    return changed;
  }

  function processCustomUnavailableControls() {
    var controls = document.querySelectorAll(
      '.tt-swatches-container-js [data-variant_availability="false"], ' +
      '.tt-swatches-container-js [data-variant-availability="false"]'
    );

    Array.prototype.forEach.call(controls, function (control) {
      control.classList.add('ssmx-option-sold-out');
      control.setAttribute('aria-disabled', 'true');
      control.setAttribute('tabindex', '-1');
    });
  }

  function applyAvailability() {
    if (!productData || isApplying) return;
    isApplying = true;

    var primaryChanged = processPrimarySelectors();
    var stickyChanged = processStickySelector();
    processCustomUnavailableControls();

    isApplying = false;

    if (primaryChanged || stickyChanged) {
      scheduleRefresh(100);
    }
  }

  function scheduleRefresh(delay) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(applyAvailability, typeof delay === 'number' ? delay : 50);
  }

  function getProductHandle() {
    var productRoot = document.querySelector('.product_page_template[data-prpageprhandle]');
    if (productRoot) return productRoot.getAttribute('data-prpageprhandle');

    var match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function fetchProductData(handle) {
    var routesRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    var url = routesRoot.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) + '.js';

    return window.fetch(url, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('No fue posible consultar las variantes del producto.');
      return response.json();
    });
  }

  function start() {
    var handle = getProductHandle();
    if (!handle || !window.fetch) return;

    fetchProductData(handle)
      .then(function (data) {
        productData = data;
        applyAvailability();
        window.setTimeout(applyAvailability, 250);
        window.setTimeout(applyAvailability, 700);

        var observer = new MutationObserver(function (mutations) {
          var shouldRefresh = mutations.some(function (mutation) {
            return mutation.addedNodes.length || mutation.removedNodes.length;
          });
          if (shouldRefresh) scheduleRefresh(40);
        });

        observer.observe(document.body, { childList: true, subtree: true });
      })
      .catch(function () {
        /* Se conserva el comportamiento original del tema si la consulta falla. */
      });
  }

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('.tt-swatches-container-js select') ||
      event.target.matches('.tt-fixed-product-wrapper select')
    ) {
      scheduleRefresh(30);
    }
  }, true);

  document.addEventListener('click', function (event) {
    var blockedControl = event.target.closest(
      '.tt-swatches-container-js .ssmx-option-sold-out, ' +
      '.tt-swatches-container-js [aria-disabled="true"]'
    );

    if (blockedControl && blockedControl.tagName !== 'OPTION') {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('shopify:section:load', function () {
    scheduleRefresh(100);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());
